const DISMISSED_KEY_PREFIX = 'jc-alert-cta-dismissed-session';

/**
 * Per-session (sessionStorage), per `surface` (e.g. 'srp', 'job-detail') so dismissing one
 * placement doesn't affect an unrelated one. Was `srp-alert-cta-session.ts`, generalized for a
 * second surface (TEC-514 #1).
 *
 * A re-arm-after-N-more-impressions model was tried (dismissing didn't hide it for the rest of
 * the session, just until the surface had been shown a few more times) and reverted: re-asking
 * someone who already said no, repeatedly across one browsing session, read as nagging rather
 * than picking up on renewed intent.
 */
export function shouldShowAlertCta(surface: string): boolean {
  if (typeof sessionStorage === 'undefined') {
    return true;
  }
  return sessionStorage.getItem(`${DISMISSED_KEY_PREFIX}:${surface}`) === null;
}

/** Call when the user dismisses an alert CTA without acting on it. Hides it for the rest of
 * this browser session. */
export function markAlertCtaDismissedThisSession(surface: string): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  sessionStorage.setItem(`${DISMISSED_KEY_PREFIX}:${surface}`, '1');
}
